import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { ExpandMore, Remove } from "@mui/icons-material";
import { useCallback, useEffect, useState } from "react";
import Loading from "./Loading";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottom: "1px solid rgba(0, 0, 0, .125)",
  "&:last-child": {
    borderBottom: 0,
  },
  "&::before": {
    display: "none",
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary expandIcon={<ExpandMore />} {...props} />
))(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    padding: "6px 0",
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({}));

export default function SideMenu({
  setCategory,
  setPriceRange,
  setLokasi,
  changeLokasi,
  changePriceRange,
  active,
  setActive,
  setNavActive,
}) {
  const [low, setLow] = useState(0);
  const [max, setMax] = useState(0);
  const [loading, setLoading] = useState(false);
  const [wilayah, setWilayah] = useState(
    JSON.parse(localStorage.getItem("wilayah")) || []
  );

  window.addEventListener("beforeunload", () => {
    localStorage.removeItem("wilayah");
  });

  useEffect(() => {
    const getWilayah = async () => {
      if (!wilayah || wilayah.length === 0) {
        setLoading(true);
        const fetchWilayah = await fetch(
          "https://kjpp-server.vercel.app/api/properties/getWilayah"
        );
        const json = await fetchWilayah.json();
        localStorage.setItem("wilayah", JSON.stringify(json));
        setWilayah(json);
        setLoading(false);
      }
    };
    getWilayah();
  }, [setWilayah]);

  const handleCategory = useCallback(
    (category) => {
      setCategory(category);
      setActive(category);
      setLokasi("all_wilayah");
    },
    [setCategory, setLokasi]
  );

  const handleWilayah = useCallback(
    (wilayah) => {
      changeLokasi(wilayah);
      setActive(wilayah);
      setCategory("all_category");
      setLokasi(wilayah);
    },
    [changeLokasi, setActive]
  );

  const handleChange = useCallback(
    (e) => {
      e.preventDefault();
      setPriceRange([parseInt(low) * 1000, parseInt(max) * 1000]);
      changePriceRange([parseInt(low) * 1000, parseInt(max) * 1000]);
    },
    [setPriceRange, low, max]
  );

  const handleReset = useCallback(
    (e) => {
      e.preventDefault();
      setPriceRange([0, 0]);
      setLow("");
      setMax("");
    },
    [setPriceRange, setLow, setMax]
  );

  return (
    <div className="py-4">
      <Accordion defaultExpanded>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
          <h1 className="font-bold">Kategori</h1>
        </AccordionSummary>
        <AccordionDetails style={{ paddingLeft: "2rem" }}>
          <button
            onClick={() => {
              handleCategory("all_category");
              setNavActive(false);
            }}
            className={`font-bold mb-2 hover:text-primary transition duration-200 ${
              active === "all_category" ? "text-primary" : ""
            }`}
          >
            Semua Kategori
          </button>
          <ul>
            <li
              className={`pl-4 mb-2 transition duration-200 rounded-md hover:bg-primary hover:text-white ${
                active === "rumah" ? "bg-primary text-white" : ""
              }`}
            >
              <button
                className="w-full text-left p-2 h-full"
                onClick={() => {
                  handleCategory("rumah");
                  setNavActive(false);
                }}
              >
                Rumah
              </button>
            </li>
            <li
              className={`pl-4 mb-2 transition duration-200 rounded-md hover:bg-primary hover:text-white  ${
                active === "ruko" ? "bg-primary text-white" : ""
              }`}
            >
              <button
                className="w-full text-left p-2 h-full"
                onClick={() => {
                  handleCategory("ruko");
                  setNavActive(false);
                }}
              >
                Ruko
              </button>
            </li>
            <li
              className={`pl-4 mb-2 transition duration-200 rounded-md hover:bg-primary hover:text-white ${
                active === "tanah" ? "bg-primary text-white" : ""
              }`}
            >
              <button
                className="w-full text-left p-2 h-full"
                onClick={() => {
                  handleCategory("tanah");
                  setNavActive(false);
                }}
              >
                Tanah
              </button>
            </li>
            <li
              className={`pl-4 mb-2 transition duration-200 rounded-md hover:bg-primary hover:text-white ${
                active === "kantor" ? "bg-primary text-white" : ""
              }`}
            >
              <button
                className="w-full text-left p-2 h-full"
                onClick={() => {
                  handleCategory("kantor");
                  setNavActive(false);
                }}
              >
                Kantor
              </button>
            </li>
          </ul>
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header">
          <h1 className="font-bold">Lokasi</h1>
        </AccordionSummary>
        <AccordionDetails style={{ paddingLeft: "2rem" }}>
          {loading && (
            <div className="h-full w-full flex justify-center items-center">
              <Loading />
            </div>
          )}
          {!loading && (
            <div>
              <button
                onClick={() => {
                  handleWilayah("all_wilayah");
                  setNavActive(false);
                }}
                className={`font-bold mb-2 hover:text-primary transition duration-200 ${
                  active === "all_wilayah" ? "text-primary" : ""
                }`}
              >
                Semua Wilayah
              </button>
              <ul>
                {wilayah &&
                  wilayah.map((wil) => (
                    <li
                      key={wil}
                      className={`pl-4 mb-2 transition duration-200 rounded-md hover:bg-primary hover:text-white  ${
                        active === wil ? "bg-primary text-white" : ""
                      }`}
                    >
                      <button
                        className="w-full text-left p-2 h-full capitalize"
                        onClick={() => {
                          handleWilayah(wil);
                          setNavActive(false);
                        }}
                      >
                        {wil}
                      </button>
                    </li>
                  ))}
              </ul>
            </div>
          )}
        </AccordionDetails>
        {!loading && (
          <div>
            {wilayah.length === 0 && (
              <h1 className="text-slate-400 w-full text-center mb-5">
                Belum ada wilayah
              </h1>
            )}
          </div>
        )}
      </Accordion>

      <Accordion defaultExpanded>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header">
          <h1 className="font-bold">Harga</h1>
        </AccordionSummary>
        <AccordionDetails>
          <div className="block items-center justify-between">
            <div className="flex w-full items-center flex-col gap-2 mb-4 xl:mb-0">
              <div className="flex items-center gap-2">
                <span>Rp.</span>
                <input
                  type="text"
                  className="border w-full text-center p-2 rounded-md"
                  value={low ? low : ""}
                  onChange={(e) => {
                    setLow(e.target.value);
                  }}
                  placeholder="From"
                />
                <span>000</span>
              </div>
              <Remove />
              <div className="flex items-center gap-2">
                <span>Rp.</span>
                <input
                  type="text"
                  className="border w-full text-center p-2 rounded-md"
                  value={max ? max : ""}
                  onChange={(e) => {
                    setMax(e.target.value);
                  }}
                  placeholder="To"
                />

                <span>000</span>
              </div>
            </div>
            <button
              onClick={(e) => {
                handleReset(e);
                setNavActive(false);
              }}
              className="w-full mt-5 text-center border border-primary px-4 py-2 rounded-md transition duration-200 hover:bg-primary hover:text-white"
            >
              Reset
            </button>
            <button
              onClick={(e) => {
                handleChange(e);
                setNavActive(false);
              }}
              className="w-full mt-5 text-center bg-primary px-4 py-2 rounded-md text-white transition duration-200 hover:opacity-80"
            >
              Save
            </button>
          </div>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
